document.addEventListener("DOMContentLoaded", async () => {

  const counter = document.querySelector(".view-counter");
  if (!counter) return;

  const type = counter.dataset.type;
  const id = counter.dataset.id;
  const title = counter.dataset.title || "";

  const API = "https://sandermoen-counter.vercel.app/api/views";

  // ---------- GET ----------
  try {

    const response = await fetch(
      `${API}?type=${encodeURIComponent(type)}&id=${encodeURIComponent(id)}`
    );

    const data = await response.json();

    if (data.success) {
      const eye = `
<svg xmlns="http://www.w3.org/2000/svg"
     width="16"
     height="16"
     viewBox="0 0 24 24"
     fill="none"
     stroke="currentColor"
     stroke-width="2"
     stroke-linecap="round"
     stroke-linejoin="round"
     style="vertical-align:-2px;margin-right:4px;">
  <path d="M1 12s4-8 11-8 11 8 11 8-4 8-11 8S1 12 1 12z"/>
  <circle cx="12" cy="12" r="3"/>
</svg>
`;

counter.innerHTML = `${eye}${data.views} views`;
    }

  } catch (e) {
    const eye = `
<svg xmlns="http://www.w3.org/2000/svg"
     width="16"
     height="16"
     viewBox="0 0 24 24"
     fill="none"
     stroke="currentColor"
     stroke-width="2"
     stroke-linecap="round"
     stroke-linejoin="round"
     style="vertical-align:-2px;margin-right:4px;">
  <path d="M1 12s4-8 11-8 11 8 11 8-4 8-11 8S1 12 1 12z"/>
  <circle cx="12" cy="12" r="3"/>
</svg>
`;

counter.innerHTML = `${eye}${data.views} views`;
  }

  // ---------- Проверка localStorage ----------

  const key = `view_${type}_${id}`;

  const last = localStorage.getItem(key);

  if (last) {

    const age = Date.now() - Number(last);

    if (age < 24 * 60 * 60 * 1000) {
      return;
    }
  }

  // ---------- POST ----------

  try {

    const response = await fetch(API, {

      method: "POST",

      headers: {
        "Content-Type": "application/json"
      },

      body: JSON.stringify({
        type,
        id,
        title
      })

    });

    const data = await response.json();

    if (data.success) {

      const eye = `
<svg xmlns="http://www.w3.org/2000/svg"
     width="16"
     height="16"
     viewBox="0 0 24 24"
     fill="none"
     stroke="currentColor"
     stroke-width="2"
     stroke-linecap="round"
     stroke-linejoin="round"
     style="vertical-align:-2px;margin-right:4px;">
  <path d="M1 12s4-8 11-8 11 8 11 8-4 8-11 8S1 12 1 12z"/>
  <circle cx="12" cy="12" r="3"/>
</svg>
`;

counter.innerHTML = `${eye}${data.views} views`;

      localStorage.setItem(key, Date.now());

    }

  } catch (e) {

    console.error(e);

  }

});